import {appRouter} from '@/router/router';

const menuListJson = localStorage.getItem('menuList');
let menuList = [];
if (menuListJson) {
    menuList = JSON.parse(menuListJson);
    localStorage.removeItem('menuList');
}

const app = {
    state: {
        brandNameIdMap:{},
        brandList:[],
        vendorNameIdMap:{},
        vendorList:[],
        seasonList:[],
        brandObjects:[],
        categoryTree:[],
        categoryIdMap:{},
        boutiqueList:[],
        promotionList:[],
        routerNameParentMap:[],
        menuTheme: 'dark', // 主题
        currentPath: [
            {
                title: 'Home',
                path: '',
                name: 'home'
            }
        ], // 面包屑数组
        menuList: menuList,
        menuMap: {},
        routers: [
            ...appRouter
        ],
        pageLoading:false
    },
    mutations: {
        setBrandNameIdMap (state, map) {
            state.brandNameIdMap = map;
        },
        setBrandList (state, list) {
            state.brandList = list;
        },
        setSeasonList (state, list) {
            state.seasonList = list;
        },
        setCategoryTree (state,trees) {
            state.categoryTree = trees;
        },
        setBoutiqueList (state, list) {
            state.boutiqueList = list;
        },
        setVendorNameIdMap (state, map) {
            state.vendorNameIdMap = map;
        },
        setVendorList (state, list) {
            state.vendorList = list;
        },

        setCategoryIdMap (state, map) {
            state.categoryIdMap = map;
        },
        setPromotionList (state, list){
            state.promotionList = list;
        },
        setRouterNameParentMap(state, map) {
            state.routerNameParentMap = map;
        },

        updateMenulist (state, menuList) {
            state.menuList = menuList;
        },
        setMenuMap(state, map) {
            state.menuMap = map;
        },

        setCurrentPath (state, pathArr) {
            state.currentPath = pathArr;
        },
        setCurrentPageName (state, name) {
            state.currentPageName = name;
        },
        setAvator (state, path) {
            localStorage.avatorImgPath = path;
        },
        setPageLoading (state,loadingStatus){
            state.pageLoading = loadingStatus;
        }
    }
};

export default app;
